<template>
  <div class="content">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <div class="row">
            <div class="col-sm-10 col-form-label uppercase">
              <strong class="first"><h3>{{$t('client.content')}}</h3></strong>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-card class="header mb-0" header-tag="header" footer-tag="footer">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong>{{ $t('common.basic_information') }}</strong>
            </div>
            <b-form v-if="item != null">
              <b-row>
                <b-col cols="12">
                  <b-tabs pills card vertical>
                    <b-tab :title="$t('client.faq')" active>
                      <b-card-text>
                        <div class="form-group row" v-for="lang in $store.getters.languages" :key="lang.id">
                          <legend class="col-sm-12 col-form-label">{{$t('common.' + lang)}}</legend>
                          <div class="col-sm-12">
                            <ckeditor :update="update" v-model="item.faq[lang]" :id="'faq_editor_' + lang" :language="lang" :height="'400px'" :uploadImageUrl="uploadImageUrl" :client="client" :x-token="xToken"></ckeditor>
                          </div>
                        </div>
                      </b-card-text>
                    </b-tab>
                    <b-tab :title="$t('client.prd_allergen')" >
                      <b-card-text>
                        <div class="form-group row" v-for="lang in $store.getters.languages" :key="lang.id">
                          <legend class="col-sm-12 col-form-label">{{$t('common.' + lang)}}</legend>
                          <div class="col-sm-12">
                            <ckeditor :update="update" v-model="item.prd_allergen[lang]" :id="'prd_allergen_editor_' + lang" :language="lang" :height="'400px'" :uploadImageUrl="uploadImageUrl" :client="client" :x-token="xToken"></ckeditor>
                          </div>
                        </div>
                      </b-card-text>
                    </b-tab>
                    <b-tab :title="$t('client.term_and_condition')" >
                      <b-card-text>
                        <div class="form-group row" v-for="lang in $store.getters.languages" :key="lang.id">
                          <legend class="col-sm-12 col-form-label">{{$t('common.' + lang)}}</legend>
                          <div class="col-sm-12">
                            <ckeditor :update="update" v-model="item.term_and_condition[lang]" :id="'term_and_condition_editor_' + lang" :language="lang" :height="'400px'" :uploadImageUrl="uploadImageUrl" :client="client" :x-token="xToken"></ckeditor>
                          </div>
                        </div>
                      </b-card-text>
                    </b-tab>
                    <b-tab :title="$t('client.cmn_commercial_transactions')" >
                      <b-card-text>
                        <div class="form-group row" v-for="lang in $store.getters.languages" :key="lang.id">
                          <legend class="col-sm-12 col-form-label">{{$t('common.' + lang)}}</legend>
                          <div class="col-sm-12">
                            <ckeditor :update="update" v-model="item.cmn_commercial_transactions[lang]" :id="'cmn_commercial_transactions_editor_' + lang" :language="lang" :height="'400px'" :uploadImageUrl="uploadImageUrl" :client="client" :x-token="xToken"></ckeditor>
                          </div>
                        </div>
                      </b-card-text>
                    </b-tab>
                    <b-tab :title="$t('client.privacy_policy')" >
                      <b-card-text>
                        <div class="form-group row" v-for="lang in $store.getters.languages" :key="lang.id">
                          <legend class="col-sm-12 col-form-label">{{$t('common.' + lang)}}</legend>
                          <div class="col-sm-12">
                            <ckeditor :update="update" v-model="item.privacy_policy[lang]" :id="'privacy_policy_editor_' + lang" :language="lang" :height="'400px'" :uploadImageUrl="uploadImageUrl" :client="client" :x-token="xToken"></ckeditor>
                          </div>
                        </div>
                      </b-card-text>
                    </b-tab>
                    <b-tab :title="$t('client.user_member_rules')" >
                      <b-card-text>
                        <div class="form-group row" v-for="lang in $store.getters.languages" :key="lang.id">
                          <legend class="col-sm-12 col-form-label">{{$t('common.' + lang)}}</legend>
                          <div class="col-sm-12">
                            <ckeditor :update="update" v-model="item.user_member_rules[lang]" :id="'user_member_rules_editor_' + lang" :language="lang" :height="'400px'" :uploadImageUrl="uploadImageUrl" :client="client" :x-token="xToken"></ckeditor>
                          </div>
                        </div>
                      </b-card-text>
                    </b-tab>
                    <b-tab :title="$t('client.membership_information')" >
                      <b-card-text>
                        <div class="form-group row" v-for="lang in $store.getters.languages" :key="lang.id">
                          <legend class="col-sm-12 col-form-label">{{$t('common.' + lang)}}</legend>
                          <div class="col-sm-12">
                            <ckeditor :update="update" v-model="item.membership_information[lang]" :id="'membership_information_editor_' + lang" :language="lang" :height="'400px'" :uploadImageUrl="uploadImageUrl" :client="client" :x-token="xToken"></ckeditor>
                          </div>
                        </div>
                      </b-card-text>
                    </b-tab>
                    <b-tab :title="$t('client.register_term_and_condition')" >
                      <b-card-text>
                        <div class="form-group row" v-for="lang in $store.getters.languages" :key="lang.id">
                          <legend class="col-sm-12 col-form-label">{{$t('common.' + lang)}}</legend>
                          <div class="col-sm-12">
                            <ckeditor :update="update" v-model="item.register_term_and_condition[lang]" :id="'register_term_and_condition_editor_' + lang" :language="lang" :height="'400px'" :uploadImageUrl="uploadImageUrl" :client="client" :x-token="xToken"></ckeditor>
                          </div>
                        </div>
                      </b-card-text>
                    </b-tab>
                    <b-tab :title="$t('client.delivery_policy')" >
                      <b-card-text>
                        <div class="form-group row" v-for="lang in $store.getters.languages" :key="lang.id">
                          <legend class="col-sm-12 col-form-label">{{$t('common.' + lang)}}</legend>
                          <div class="col-sm-12">
                            <ckeditor :update="update" v-model="item.delivery_policy[lang]" :id="'delivery_policy_editor_' + lang" :language="lang" :height="'400px'" :uploadImageUrl="uploadImageUrl" :client="client" :x-token="xToken"></ckeditor>
                          </div>
                        </div>
                      </b-card-text>
                    </b-tab>
                    <b-tab :title="$t('client.campaigns_term_and_condition')" >
                      <b-card-text>
                        <div class="form-group row" v-for="lang in $store.getters.languages" :key="lang.id">
                          <legend class="col-sm-12 col-form-label">{{$t('common.' + lang)}}</legend>
                          <div class="col-sm-12">
                            <ckeditor :update="update" v-model="item.campaigns_term_and_condition[lang]" :id="'campaigns_term_and_condition_editor_' + lang" :language="lang" :height="'400px'" :uploadImageUrl="uploadImageUrl" :client="client" :x-token="xToken"></ckeditor>
                          </div>
                        </div>
                      </b-card-text>
                    </b-tab>
                  </b-tabs>
                </b-col>
              </b-row>
            </b-form>
            <div slot="footer">
              <div class="btn-save">
                <button type="button" class="btn bg-main border-radius-4px pl-3 pr-3" v-on:click="saveContent"> {{$t('common.save')}}</button>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import cSwitch from '../../../components/Switch'
  import Tables from '../../tables/Tables'
  import Multiselect from 'vue-multiselect'
  import Ckeditor from '../../editors/CKEditor'
  let vm = null

  export default {
    name: 'Content',
    props: {
    },
    components: {
      Tables,
      cSwitch,
      Multiselect,
      Ckeditor
    },
    data: function () {
      return {
        update: false,
        uploadImageUrl: '',
        xToken: '',
        client: localStorage.getItem('clientID'),
        item: {
          client_id: this.$store.getters.config.base.id,
          faq: {},
          prd_allergen: {},
          term_and_condition: {},
          cmn_commercial_transactions: {},
          privacy_policy: {},
          user_member_rules: {},
          membership_information: {},
          register_term_and_condition: {},
          delivery_policy: {},
          campaigns_term_and_condition: {}
        }
      }
    },
    methods: {
      saveContent () {
        let data1 = this._.cloneDeep(vm.item)
        data1.prd_allergen = data1.prd_allergen || ''
        data1.term_and_condition = data1.term_and_condition || ''
        data1.cmn_commercial_transactions = data1.cmn_commercial_transactions || ''
        data1.privacy_policy = data1.privacy_policy || ''
        data1.user_member_rules = data1.user_member_rules || ''
        data1.membership_information = data1.membership_information || ''
        data1.register_term_and_condition = data1.register_term_and_condition || ''
        data1.delivery_policy = data1.delivery_policy || ''
        data1.campaigns_term_and_condition = data1.campaigns_term_and_condition || ''

        data1.faq = btoa(unescape(encodeURIComponent(JSON.stringify(data1.faq))))
        data1.prd_allergen = btoa(unescape(encodeURIComponent(JSON.stringify(data1.prd_allergen))))
        data1.term_and_condition = btoa(unescape(encodeURIComponent(JSON.stringify(data1.term_and_condition))))
        data1.cmn_commercial_transactions = btoa(unescape(encodeURIComponent(JSON.stringify(data1.cmn_commercial_transactions))))
        data1.privacy_policy = btoa(unescape(encodeURIComponent(JSON.stringify(data1.privacy_policy))))
        data1.user_member_rules = btoa(unescape(encodeURIComponent(JSON.stringify(data1.user_member_rules))))
        data1.membership_information = btoa(unescape(encodeURIComponent(JSON.stringify(data1.membership_information))))
        data1.register_term_and_condition = btoa(unescape(encodeURIComponent(JSON.stringify(data1.register_term_and_condition))))
        data1.delivery_policy = btoa(unescape(encodeURIComponent(JSON.stringify(data1.delivery_policy))))
        data1.campaigns_term_and_condition = btoa(unescape(encodeURIComponent(JSON.stringify(data1.campaigns_term_and_condition))))

        vm.axios.tenant.updateContentClient(data1, function (response) {
          vm.$toastr.success(vm.$t('message.save_successful'), vm.$t('message.success'), {})
        }, function () {
        })
      }
    },
    created: function () {
      this.uploadImageUrl = process.env.host + '/' + process.env.version + '/' + process.env.prefix_tenant + '/content/upload-image'
      this.xToken = this.$auth.user().token
      vm = this
      vm.axios.tenant.getContentClient(
        function (response) {
          let item = response.data.data.item
          if (item != null) {
            vm.item = item
            vm.update = true
          }
        })
    },
    mounted: function () {
      if (vm.uuid == 'create' || vm.uuid == undefined) {
      } else {
        let vm = this
      }
    }
  }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
  .cke_menu_panel iframe:not(.md-image) {
    height: inherit;
  }
</style>
<style scoped>
  .content div.header,
  .content .header .card-header{
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
  }
  .content .card-footer{
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 7.75px;
    border-top: none;
    margin-top: 1.5rem;
    z-index: 999;
  }
  .content .card-footer .btn-save{
    float: right;
    margin-right: 22px;
  }
  .table td {
    padding: 5px 0.75rem;
  }
</style>



// WEBPACK FOOTER //
// src/views/admin/client/Content.vue